export { PreloadImageComponent } from './preload-image/preload-image.component';

export { AlertComponent } from './alert/alert.component';
export { NotificationComponent } from './notification/notification.component';
export { FileUploaderDirective } from './file-uploader/file-uploader.directive';

export { SharedModule } from './shared.module';



// WEBPACK FOOTER //
// ./src/app/shared/index.ts